import axios from "axios"

function getSchoolAssessments({}, {}, params) {
    return axios.get(`api/v1/school-assessments`, { params })
}

function getSchoolAssessment({ id }) {
    return axios.get(`api/v1/school-assessments/${id}`)
}

function createSchoolAssessment({}, formData) {
    return axios.post(`api/v1/school-assessments`, formData)
}

function updateSchoolAssessment({ id }, formData) {
    return axios.put(`api/v1/school-assessments/${id}`, formData)
}

function deleteSchoolAssessment({ id }) {
    return axios.delete(`api/v1/school-assessments/${id}`)
}

function processSchoolAssessment({}, formData) {
    return axios.post(`api/v1/school-assessments/process`, formData)
}

export const schoolAssessmentsService = {
    getSchoolAssessments,
    getSchoolAssessment,
    createSchoolAssessment,
    updateSchoolAssessment,
    deleteSchoolAssessment,
    processSchoolAssessment,
}
